import { ReactElement, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { raiseErrorBanner } from '../../../../../components/MessageDispatch/messageDispatch';
import { catchAxiosError } from '../../../../../services/axios/_utility';
import TextBox from '../../../../../components/Form/TextBox/TextBox';
import { LABEL_POSITIONS } from '../../../../../components/Form/_constants';
import { getEmailSuffix } from './_api';
import { FORM_KEYS } from '../../_constants';

/**
 * Create contextualized textbox for alternate email address
 * @returns {ReactElement} Alternate Email Address Form Group
 */
const AlternateEmailTextBox = ({ labelPosition, ...props }) => {
	const dispatch = useDispatch();
	const [sCustomError, setCustomError] = useState('');
	const [suffixList, setSuffixList] = useState([]);

	useEffect(() => {
		let isMounted = true;
		getEmailSuffix()
			.then(payload => {
				if (isMounted) {
					setSuffixList(payload);
				}
			})
			.catch(error => {
				raiseErrorBanner(catchAxiosError(error), dispatch);
			});
		return () => (isMounted = false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<TextBox
			help='Must be a valid non-UPMC email.'
			inputProps={{
				type: 'email',
				required: true,
				customError: sCustomError,
			}}
			label='Alternate Email Address'
			labelPosition={labelPosition ? labelPosition : LABEL_POSITIONS.TOP}
			name={props.name ? props.name : FORM_KEYS.ALTERNATE_EMAIL_ADDRESS}
			onError={error => setCustomError(error)}
			placeholder='Alternate Email Address'
			validate={value => {
				let errorMessage;
				const suffixFound = suffixList.some(s => {
					return !!value && value.includes(s);
				});
				if (suffixFound) {
					errorMessage =
						'Please provide a valid non-UPMC email address.';
				}
				setCustomError(errorMessage ? errorMessage : '');
				return errorMessage;
			}}
			{...props}
		/>
	);
};

AlternateEmailTextBox.propTypes = {};

export { AlternateEmailTextBox };
